import React from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import styles from './styles.module.scss'

const capitalize = value => {
  if (!value) {
    return '-'
  }

  const text = String(value).replaceAll('_', ' ')

  return text.charAt(0).toUpperCase() + text.slice(1)
}

const statusColors = {
  paid: {
    background: '#D1F9CB',
    text: '#32BF1F',
    border: '#BEF3B7',
  },
  draft: {
    background: '#FFD4A5',
    text: '#D77000',
    border: '#E7C88C',
  },
  billed: {
    background: '#D1F9CB',
    text: '#32BF1F',
    border: '#BEF3B7',
  },
  sent: {
    background: '#ECF0FF',
    text: '#6D75E8',
    border: '#D3D6FA',
  },
  overdue: {
    background: '#FFBDBD',
    text: '#D70000',
    border: '#F77C7C',
  },
  default: {
    background: '#E9E9E9',
    text: '#919191',
    border: '#C6C6C6',
  }
}

const getStatusStyles = status => {
  const colors = statusColors[status] || statusColors['default']
  return {
    backgroundColor: colors.background,
    color: colors.text,
    border: `1px solid ${colors.border}`,
  }
}

const getStatusText = (status, dueDate) => {
  if (!dueDate) {
    return status
  }
  if (moment().isAfter(moment(dueDate)) && status !== 'paid') {
    return 'overdue'
  }
  return status
}

const InvoiceStatus = ({ status, dueDate }) => {
  const { t } = useTranslation()

  const statusText = getStatusText(status, dueDate)
  
  return (
    <div className={styles.container} style={getStatusStyles(statusText)}>
      {
        status === 'paid'
          ? <div className={styles.dot} />
          : null
      }
      { t(capitalize(statusText)) }
    </div>
  )
}

export default InvoiceStatus